export default "__VITE_ASSET__CNDwbs30__"